import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { fetchGetProduct } from "./diegoVpnAPI";

export const getProducts = createAsyncThunk(
	'diegoVpn/getProduct',
	async (pid) => {
		const response = await fetchGetProduct(pid)
		return response;
	}
)

const diegoVpnSlice = createSlice({
	name: "diegoVpn",
	initialState: {
		status: "",
		error: "",
		vpn: "",
	},
	extraReducers: (builder) => {
		builder
			.addCase(getProducts.pending, (state) => {
				state.status = 'loading'
			})
			.addCase(getProducts.fulfilled, (state, action) => {
				const resData = action.payload.products.product
				state.status = 'fulfilled'
				state.vpn = resData
			})
			.addCase(getProducts.rejected, (state, action) => {
				state.status = 'error'
				state.error = action.error.message
			})
	},
})

export default diegoVpnSlice.reducer;